import { detectDevice } from './detectDevice'

export const isMobileDevice = (): boolean => {
  const device = detectDevice()
  return device === 'iOS' || device === 'Android'
}
